module.exports = __webpack_public_path__ + "static/img/icon-menu1-2.e43f47eb.svg";